import { publicFlowMessages } from './public-flow-messages.js';
import { remainingMessages } from './remaining-messages.js';
import { messages } from './messages.js';
import { marketingMessages } from './marketing-messages.js';
import { marketingFaqMessages } from './marketing-faq-messages.js';
import { technologyFaqMessages } from './technology-faq-messages.js';
import { technologyMessages } from './technology-messages.js';
import { mcpMessages } from './mcp-messages.js';
import { articleMessages } from './article-messages.js';
import { enlacesMessages } from './enlaces-messages.js';
import { newsletterMessages } from './newsletter-messages.js';
import { seguridadMessages } from './seguridad-messages.js';
import { sostenibilidadMessages } from './sostenibilidad-messages.js';

// translate() busca la clave con los espacios normalizados y sin espacios en los bordes, y repone después los
// espacios del texto original. Por eso el catálogo se normaliza igual: una clave como 'Tu marca, ' (con espacio al
// final, para separar del <span> que sigue) no se encontraba y esa parte del título quedaba en español.
const normalizar = (texto) => texto.replace(/\s+/g, ' ').trim();
const recortar = (v) => (typeof v === 'string' ? v.replace(/^\s+|\s+$/g, '') : v);

const crudo = {
  ...sostenibilidadMessages,
  ...seguridadMessages,
  ...newsletterMessages,
  ...enlacesMessages,
  ...mcpMessages,
  ...articleMessages,
  ...messages,
  ...marketingMessages,
  ...marketingFaqMessages,
  ...technologyMessages,
  ...technologyFaqMessages,
  ...publicFlowMessages,
  ...remainingMessages,
};

export const catalog = Object.fromEntries(
  Object.entries(crudo).map(([clave, traducciones]) => [
    normalizar(clave),
    Array.isArray(traducciones) ? traducciones.map(recortar) : traducciones,
  ])
);
